import { hideLoader } from "action/loader/hideLoader";
import { showLoader } from "action/loader/showLoader";
import { openModal } from "action/modal/openModal";
import { setProductDeliveryDetails } from "action/utils/setProductDeliveryDetails";
import AmpService from "analytics/amplitude/amplitudeEvents";
import { getProductDeliveryDetailsSkuApi } from "api/product/getProductDeliveryDetailsSkuApi";
import { addItemApi } from "api/shopping-cart/addItemApi";
import { checkItemFitmentApi } from "api/shopping-cart/checkItemFitmentApi";
import { IShoppingCartStateReducer } from "reducer/shopping-cart.reducer";
import { sendAddToCartEvent } from "util/analytics/sendAddToCartEvent";
import PASentry from "util/pa-sentry";
import { PRODUCT_PAGE_TYPES } from "util/product/product-constants";
import getCustomSizeQuery from "util/url/getCustomSizeQuery";
import { validateVehicle } from "util/vehicle/validate-vehicle";
import { addItemSuccess } from "./addItemSuccess";
import { refreshShoppingCart } from "./refreshShoppingCart";

function _addItem(dispatch: any, state: IShoppingCartStateReducer, product: any, vehicle: any, resolve, reject,
  {
    quantity = 1, loc, pageType, fitmentOptionsDetails, openSuggestedQtyModal, modalData,
  }, callback: any) {
  const { sku } = product;

  const { customTireSize: customTireSizes, customWheelSize: customWheelSizes } = getCustomSizeQuery();

  if (openSuggestedQtyModal && callback) {
    dispatch(
      openModal("suggestedQuantityModal", {
        title: "product_check_fitment",
        product,
        quantity,
        ...modalData,
      }),
    );
    return;
  }

  addItemApi(sku, vehicle, quantity, { customTireSizes, customWheelSizes })
    .then(({ data }) => {
      if (data.successful) {
        const addToCartSuccess = () => {
          sendAddToCartEvent({ ...product, quantity }, vehicle);
          AmpService.addToCartConfirmed(product, loc);

          // TODO: need to revise this flow
          dispatch(addItemSuccess(state.availableItems));
          resolve(data);
        };
        if (PRODUCT_PAGE_TYPES.includes(pageType)) {
          getProductDeliveryDetailsSkuApi(product.sku, state.postalCode, quantity)
            .then(({ data: productDeliveryApiData }) => {
              const { productDeliveryDetails } = productDeliveryApiData;
              dispatch(setProductDeliveryDetails(productDeliveryDetails.availableDeliveryMethodsDetails));
              addToCartSuccess();
            });
        } else {
          addToCartSuccess();
        }
      }
      if (!data.successful) {
        dispatch(
          openModal("insufficientStock", {
            failureMessage: data.failureMessage,
            product,
            errorType: data.errorType,
            onClose: () => {
              // if (callback) {
              //   callback(response.data);
              // }
            },
          }),
        );
        // refreshShoppingCart to sync quantity.
        dispatch(refreshShoppingCart(null, { loader: false }));
        reject({
          fitmentOptionsDetails,
          updatedProduct: product,
        });
      } else if (callback) {
        callback({
          fitmentOptionsDetails,
          updatedProduct: product,
        });
      }
    }).catch((err) => {
      dispatch(hideLoader());
      console.log("err.message", err.message);
      console.log("err", err);
      PASentry.logException(err);
      reject(err);
    });
}

export function addItem(
  product: any,
  vehicle = undefined,
  { skipValidation = false, quantity = 1, skipSuggestedQtyModal = false },
  callback?: any,
) {
  return (dispatch: any, getState: any) => new Promise((resolve, reject) => {
    const { sku, description } = product;
    const state = getState().shoppingCart;
    const { utils, garage, shoppingCart } = getState();
    const { availableItems } = shoppingCart;

    // If vehicle isn't informed and the selected vehicle is valid
    if (!vehicle) {
      const { selectedVehicle } = getState().garage;
      if (validateVehicle(selectedVehicle)) {
        // eslint-disable-next-line no-param-reassign
        vehicle = { ...selectedVehicle };
      }
    }

    const checkFitment = skipValidation || product.fitment === "UNKNOWN" || !validateVehicle(vehicle);
    if (!checkFitment) {
      dispatch(showLoader());
      checkItemFitmentApi(sku, vehicle)
        .then(({ data }) => {
          const {
            fitmentOptionsDetails, remainingFitmentOptions,
            relevantSelectedFitmentOptions, message,
            fitmentStatus, fitmentNote,
          } = data;
          const recommendedQuantity = fitmentNote?.jsonNote?.fitmentNotes?.[0].q;
          const openSuggestedQtyModal = !(availableItems.some((el) => el.sku === product.sku))
           && recommendedQuantity && quantity < recommendedQuantity && !skipSuggestedQtyModal;
          const successful = fitmentStatus === "GUARANTEED_FIT";
          dispatch(hideLoader());
          const updatedProduct = {
            ...product,
            remainingFitmentOptions,
            relevantSelectedFitmentOptions,
            fitmentStatus,
            fitmentNote,
          };
          if (successful) {
            if (message === "VEHICLE_NOT_REQUIRED") {
            // eslint-disable-next-line no-param-reassign
              vehicle = undefined;
            }
            _addItem(dispatch, state, updatedProduct, vehicle, resolve, reject, {
              quantity: openSuggestedQtyModal ? recommendedQuantity : quantity,
              loc: utils.addToCartLocation,
              pageType: utils.currentPageType,
              fitmentOptionsDetails,
              openSuggestedQtyModal,
              modalData: { message },
            }, callback);
          } else {
            AmpService.addToCartAttempted(updatedProduct, garage.selectedVehicle, utils.addToCartLocation);
            dispatch(
              openModal(openSuggestedQtyModal ? "suggestedQuantityModal" : "checkFitmentModel", {
                title: "product_check_fitment",
                product: updatedProduct,
                sku,
                description,
                message,
                quantity: openSuggestedQtyModal ? recommendedQuantity : quantity,
                // addItem: true,
                addProductToCart: true,
                fitmentOptionsDetails,
              }),
            );
          }
        }).catch((err) => {
          reject(err);
          dispatch(hideLoader());
        });
    } else {
      _addItem(dispatch, state, product, vehicle, resolve, reject, {
        quantity,
        loc: utils.addToCartLocation,
        pageType: utils.currentPageType,
        fitmentOptionsDetails: undefined,
        openSuggestedQtyModal: false,
        modalData: {},
      }, callback);
    }
  });
}
